import { useContext, useEffect, useState } from "react";
import CountUp from "react-countup";
import EnterpriseService from "../../common/services/enterprise-service";
import Loader from "../ui/Loader";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";
import { EnterpriseContext } from "./EnterpriseContext";

const AggregatedStatsPerGame = ({ container, user }) => {
  const [stats, setStats] = useState(null);
  const es = new EnterpriseService();
  const [loading, setLoading] = useState(false);

  const { globalContext } = useContext(EnterpriseContext);
  const member = globalContext.member;

  useEffect(() => {
    getStats();
  }, [user]);

  const getStats = async () => {
    setLoading(true);
    const result = await es.getAggregatedStatsPerGame(user.id, 1);
    const result2 = await es.getAggregatedStatsPerGame(user.id, 2);
    setStats({ ets2: result, ats: result2 });
    setLoading(false);
  };

  const renderStatsCell = (value, counted, unit) => {
    return (
      <div className="stat-tile stat-tile-info per-game-cell text-center">
        {counted && (
          <CountUp
            separator=" "
            decimals={0}
            decimal="," end={value}
            suffix={unit ? ` ${unit}` : ""}
            className="fs-4 fw-bolder"
          ></CountUp>
        )}
        {!counted && <span className="fs-4 fw-bolder">{value}</span>}
      </div>
    );
  };

  const renderStatsRow = (label, key, counted, toFixed, unit) => {
    const translatedLabel = container.localeManager.strings[label];
    const games = ["ets2", "ats"];
    const gamesIds = [1, 2];

    return (
      <div className="per-game-row" key={key}>
        <div className="per-game-row-label">{translatedLabel}</div>
        {games.map((game, index) => {
          if (stats[game] === undefined || stats[game][key] === undefined)
            return null;

          let rawValue = stats[game][key];
          let userUnit = unit;
          let isCounted = counted;

          if (isCounted && rawValue == "-") isCounted = false;

          if (isCounted && rawValue == 0) {
            rawValue = "-";
            isCounted = false;
          }

          if (unit == "KM") {
            userUnit = UserDefinedUnits.getDistanceUnitLabel(
              member,
              gamesIds[index],
            );
            rawValue = UserDefinedUnits.convertDistanceValue(
              member,
              gamesIds[index],
              rawValue,
            );
          }

          return (
            <div key={`${key}_${game}`}>
              {renderStatsCell(rawValue, isCounted, userUnit)}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      {loading && <Loader></Loader>}
      {!loading && stats != null && (
        <div className="user-per-game-modern">
          <div className="per-game-row per-game-row-header">
            <div className="per-game-row-label"></div>
            <div className="per-game-logo-box text-center">
              <img
                src={window.overwolf ? "assets/games/ets2.png" : "/assets/games/ets2.png"}
                className="h-70px"
              />
            </div>
            <div className="per-game-logo-box text-center">
              <img
                src={window.overwolf ? "assets/games/ats.png" : "/assets/games/ats.png"}
                className="h-70px"
              />
            </div>
          </div>
          {renderStatsRow("preferred_brand", "preferred_brand")}
          {renderStatsRow("distance_driven_on_job", "distance_driven_on_job_km", true, true, "KM")}
          {renderStatsRow("jobs_delivered", "jobs_delivered", true)}
          {renderStatsRow("max_real_distance", "max_real_distance_km", true, true, "KM")}
          {renderStatsRow("avg_real_distance", "avg_real_distance_km", true, true, "KM")}
          {renderStatsRow("most_source_company", "most_source_company")}
          {renderStatsRow("company_trailer_deliveries", "company_trailer_deliveries", true)}
          {renderStatsRow("owned_trailer_deliveries", "owned_trailer_deliveries", true)}
          {renderStatsRow("wotr_contracts", "wotr_contracts", true)}
          {renderStatsRow("most_source_city", "most_source_city")}
          {renderStatsRow("most_destination_company", "most_destination_company")}
          {renderStatsRow("most_delivered_cargo", "most_delivered_cargo")}
        </div>
      )}
    </>
  );
};

export default AggregatedStatsPerGame;
